// extracted by mini-css-extract-plugin
export var socialIcons = "social-icons-module--socialIcons--Ijkmg";